import { useMemo, useState } from "react";
import { SciOutputBox, SciTextArea } from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { type SeqOp, transformSequence } from "../lib/reverse-complement";

const OPS: { value: SeqOp; label: () => string }[] = [
  { value: "reverse-complement", label: () => m.revcomp_op_revcomp() },
  { value: "complement", label: () => m.revcomp_op_comp() },
  { value: "reverse", label: () => m.revcomp_op_rev() },
];

export function ReverseComplementCalc() {
  const [seq, setSeq] = useState("");
  const [op, setOp] = useState<SeqOp>("reverse-complement");
  const [rna, setRna] = useState(false);

  const result = useMemo(() => transformSequence(seq, op, rna), [seq, op, rna]);

  return (
    <div className="sci-card rounded-2xl p-6 sm:p-8">
      <SciTextArea
        id="revcomp-input"
        label={m.revcomp_input_label()}
        value={seq}
        placeholder={m.revcomp_input_placeholder()}
        onChange={setSeq}
      />

      <div className="mt-4 flex flex-wrap items-center gap-2">
        {OPS.map((o) => (
          <button
            key={o.value}
            type="button"
            aria-pressed={op === o.value}
            onClick={() => setOp(o.value)}
            className={
              op === o.value
                ? "sci-result-zone sci-result rounded-md px-3 py-1.5 text-sm font-semibold"
                : "sci-panel rounded-md px-3 py-1.5 text-sm text-muted-foreground transition-colors hover:text-foreground"
            }
          >
            {o.label()}
          </button>
        ))}
        <label className="ml-auto flex items-center gap-2 text-sm text-muted-foreground">
          <input
            type="checkbox"
            checked={rna}
            onChange={(e) => setRna(e.target.checked)}
            className="h-4 w-4 accent-[var(--accent-c)]"
          />
          {m.revcomp_rna_label()}
        </label>
      </div>

      {result.output ? (
        <>
          <SciOutputBox
            label={m.revcomp_output_label()}
            value={result.output}
            testId="revcomp-output"
          />
          <p className="mt-2 text-xs text-muted-foreground">
            {m.revcomp_length({ n: result.input.length })}
          </p>
        </>
      ) : (
        <p className="mt-5 text-sm text-muted-foreground">
          {m.revcomp_hint_empty()}
        </p>
      )}
    </div>
  );
}
